import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const BenchmarkingDetailsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 444px;

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    height: 40px;
    margin-top: 24px;

    .header-title {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.bold};
      font-size: ${theme.typography.fontSize.xxxLarge};
      color: ${theme.colors.menuItemText};
      line-height: normal;
    }

    .close-button {
      cursor: pointer;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: ${theme.attributes.borderRadius.secondary};
      transition: background-color 0.2s ease;

      path {
        stroke: ${theme.colors.menuItemText};
      }

      &:hover {
        background-color: rgba(255, 255, 255, 0.08);

        html[data-theme='light'] & {
          background-color: ${theme.colors.menuItemHover};
        }
      }
    }
  }

  .content-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    margin-top: 32px;
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.normal};
    font-size: ${theme.typography.fontSize.large};
    line-height: 22px;
    color: ${theme.colors.dropdownLabel};

    .highlight {
      color: ${theme.colors.menuItemText};
    }
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    padding-left: 32px;
    padding-right: 4px;
    margin-top: 12px;
    flex: 1;
    overflow: hidden;

    .table-container {
      flex: 1;
      overflow-y: auto;
      overflow-x: auto;
      padding-bottom: 32px;

      ::-webkit-scrollbar {
        background: transparent;
        width: 20px !important;
      }

      ::-webkit-scrollbar-track {
        background: transparent;
        margin: 0 0 ${theme.spacing.medium}px 0;
      }

      ::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.borderMedium};
        border-radius: 9999px;
        border-right: 8px solid transparent;
        border-left: 8px solid transparent;
        background-clip: padding-box;
      }

      table {
        border-collapse: separate;
        border-spacing: 0 4px;
        width: 100%;
        font-size: ${theme.typography.fontSize.large};
      }

      thead tr {
        background-color: ${theme.colors.borderMedium};
      }

      thead th {
        padding: 14px 8px;
        text-align: left;
        color: ${theme.colors.devicesSecondaryText};
        font-weight: ${theme.typography.fontWeight.normal};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        line-height: 22px;
        border-top: 1px solid ${theme.colors.borderMedium};
        border-bottom: 1px solid ${theme.colors.borderMedium};
        border-left: none;
        border-right: none;
        height: 50px;
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      thead th:first-of-type {
        border-left: 1px solid ${theme.colors.borderMedium};
        border-top-left-radius: ${theme.attributes.borderRadius.tertiary};
        border-bottom-left-radius: ${theme.attributes.borderRadius.tertiary};
        padding-left: 24px;
      }

      thead th:last-of-type {
        border-right: 1px solid ${theme.colors.borderMedium};
        border-top-right-radius: ${theme.attributes.borderRadius.tertiary};
        border-bottom-right-radius: ${theme.attributes.borderRadius.tertiary};
      }

      tbody tr:nth-of-type(odd) {
        background-color: transparent;
      }

      tbody tr:nth-of-type(even) {
        background-color: ${theme.colors.labelCardBg};
      }

      tbody tr:hover {
        background-color: ${theme.colors.devicesRowHoverBg};
      }

      tbody td {
        padding: 8px;
        color: ${theme.colors.menuItemText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        line-height: 20px;
        font-weight: ${theme.typography.fontWeight.normal};
        border-top: 1px solid ${theme.colors.borderMedium};
        border-bottom: 1px solid ${theme.colors.borderMedium};
        border-left: none;
        border-right: none;
        height: 60px;
        box-sizing: border-box;
      }

      tbody td:first-of-type {
        border-left: 1px solid ${theme.colors.borderMedium};
        border-top-left-radius: ${theme.attributes.borderRadius.tertiary};
        border-bottom-left-radius: ${theme.attributes.borderRadius.tertiary};
        padding-left: 24px;
      }

      tbody td:last-of-type {
        border-right: 1px solid ${theme.colors.borderMedium};
        border-top-right-radius: ${theme.attributes.borderRadius.tertiary};
        border-bottom-right-radius: ${theme.attributes.borderRadius.tertiary};
      }

      .cpi-cell {
        display: flex;
        align-items: center;
        gap: 16px;
      }

      .cpi-chip {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: ${theme.colors.btnTertiaryBg};
        border-radius: 18px;
        padding: 2px 8px;
        width: 72px;
        height: 24px;
        box-sizing: border-box;
        white-space: nowrap;

        span {
          font-family: ${theme.typography.fontFamily.primary};
          font-weight: ${theme.typography.fontWeight.bold};
          font-size: ${theme.typography.fontSize.medium};
          color: ${theme.colors.devicesSecondaryText};
          letter-spacing: 0.5px;
          line-height: 16px;
          text-align: center;
        }
      }

      .cpi-name {
        color: ${theme.colors.devicesSecondaryText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .status-chip {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 58px;
        height: 28px;
        padding: 4px 16px;
        border-radius: 6px;
        box-sizing: border-box;
        white-space: nowrap;
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.extraThick};
        font-size: ${theme.typography.fontSize.medium};
        letter-spacing: 0.1px;
        line-height: 20px;
        text-align: center;

        &.less-strict {
          background: rgba(142, 154, 255, 0.15);
          color: #8E9AFF;
        }

        &.same-sla {
          background: rgba(255, 193, 106, 0.15);
          color: #F09543;
        }

        &.more-strict {
          background: rgba(255, 127, 107, 0.15);
          color: #FF7F6B;
        }
      }
    }
  }

  .modal-footer {
    position: relative;
    display: flex;
    align-items: center;
    padding: 24px 32px 32px;
    height: 96px;
    box-sizing: border-box;
    border-top: 1px solid ${theme.colors.dropdownBorder};

    .result-label {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.bold};
      font-size: ${theme.typography.fontSize.header};
      color: ${theme.colors.menuItemText};
      line-height: normal;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .result-value {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.extraThick};
      font-size: ${theme.typography.fontSize.xLarge};
      color: ${theme.colors.menuItemText};
      line-height: 20px;
    }
  }
`
